export default __webpack_public_path__ + "images/UB.9c4b78d.png";